import { Injectable } from "@angular/core";
import * as moment from "moment";
import { SignalRConnection } from "ng2-signalr";
import { UserPreference } from "../../models/UserPreference";
import { errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { DashboardService } from "../dashboard.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";

@Injectable()
export class OpensorterordersService extends BaseService{
  
  constructor(
    private _dashboardService: DashboardService,
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) { 
    super();
  }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {
    console.log('OpenSorterOrders');
    widget.hub.listenFor("broadcastOpensorterorders").subscribe(
      (result: any) => {
        console.log("broadcastOpensorterorders", result);
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        if (result && result.length > 0) {
          //console.log(result[0].IsNoDataFound);
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
          widget.dataLoaded = false;
          widget.chartOptions = this.chartOptions();
          widget.errorMessage = null;
          if(widget.IfNoDataFound){
            widget.errorMessage = errorMessages.noWidgetData;
          }else if (widget.IfNoDataFound == null) {
            widget.errorMessage = "Retrieving records. Please wait...";
          }
          else{
            let hosSummary: any = result[0];
            this.addDataSeries(widget.chartOptions, [hosSummary.BTW_0_1_HRS_AGING_ORDERS_CNT,
              hosSummary.BTW_1_2_HRS_AGING_ORDERS_CNT,
              hosSummary.BTW_2_6_HRS_AGING_ORDERS_CNT,
              hosSummary.BTW_6_24_HRS_AGING_ORDERS_CNT,
              hosSummary.OVER_24_AGING_ORDERS_CNT,
              ], 'Open Sorter Orders', 'bar');
              widget.chartOptions.xAxis.data = ['Below 1 hr', '1-2 Hrs', '2-6 Hrs', '6-24 Hrs', 'Above 24 Hrs'];          
            widget.errorMessage = null;
          }
        }
        widget.dataLoaded = true;
        this._commonService.lastUpdatedTime = lastUpdatedTime;
        
      },
      err => {
        console.log("listenFor broadcastOpensorterorders error", err);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/opensorterorders.service.ts